module.exports = __webpack_public_path__ + "static/media/logo-footer.a1aef428.svg";